module.exports = __webpack_public_path__ + "img/marcapais.641b03cc.png";